import { gql } from '@apollo/client';

// Query to search for organisations
export const SEARCH_ORGANISATIONS = gql`
  query SearchOrganisations @cached {
    organisations(order_by: { name: asc }) {
      id
      name
    }
  }
`;

// Query to search for targets within a specific organisation
export const SEARCH_ORG_TARGETS = gql`
  query SearchOrgTargets($organisationId: Int!) @cached {
    search_results: targets(
      where: { organisation_id: { _eq: $organisationId } },
      order_by: { name: asc },
    ) {
      id
      name
      organisation {
        id
        name
      }
    }
  }
`;

export const GET_ALL_ORGANISATIONS = gql`
  query GetAllOrganisations {
    organisations(order_by: {name: asc}) {
      id
      name
      platform
      targets {
        id
        name
      }
    }
  }
`;

export const ORG_SEARCH_BY_NAME_OR_DOMAIN = gql`
  query OrgSearchByNameOrDomain($search: String!) {
    organisations(where: {
      _or: [
        { name: { _ilike: $search } },
        { targets: { name: { _ilike: $search } } }
      ]
    }, order_by: { id: asc, name: asc }, distinct_on: id) {
      id
      name
      targets(where: {name: {_ilike: $search}}, limit: 1) {
        name
      }
    }
  }
`;

// For future: Query to get memory bank entries (if implemented on backend)
export const GET_MEMORY_BANK_ENTRIES = gql`
  query GetMemoryBankEntries($targetId: Int!) @cached {
    memory_bank_entries(
      where: { target_id: { _eq: $targetId } },
      order_by: { created_at: desc }
    ) {
      id
      content
      created_at
      metadata
    }
  }
`; 